import { IStyle, mergeStyleSets, Theme, useTheme } from "@fluentui/react";
import * as React from "react";
import { visuallyHidden } from "sh-application/utility/styling";

type IShiftsDialogKeys =
    | "accessibilityAlert"
    | "buttonSpacing"
    | "header"
    | "hideButton"
    | "scrollableContent";

type IShiftsDialogClassNames = Record<IShiftsDialogKeys, string>;

type IShiftsDialogStyles = Record<IShiftsDialogKeys, IStyle>;

export type IPartialShiftsDialogStyles = Partial<IShiftsDialogStyles>;

type IShiftsDialogProps = {
    theme: Theme;
    overrides?: IPartialShiftsDialogStyles;
};

// Fixed class names are needed for the unit tests.
const fixedClassNames: Pick<IShiftsDialogClassNames, "accessibilityAlert" | "hideButton"> = {
    accessibilityAlert: "accessibilityAlert",
    hideButton: "hideButton"
};

const getShiftsDialogClassNames = ({ overrides }: IShiftsDialogProps): IShiftsDialogClassNames => {
    return mergeStyleSets(
        {
            header: {
                height: 24
            },
            scrollableContent:  {
                overflow: "hidden"
            },
            accessibilityAlert: [visuallyHidden, fixedClassNames.accessibilityAlert],
            buttonSpacing: {
                marginRight: 9
            },
            hideButton: [
                {
                    display: "none"
                },
                fixedClassNames.hideButton
            ]
        },
        overrides
    );
};

export function useShiftsDialogClassNames(overrides?: IPartialShiftsDialogStyles) {
    const theme = useTheme();
    return React.useMemo(() => getShiftsDialogClassNames({ theme, overrides }), [theme, overrides]);
}
